import { render, staticRenderFns } from "./ProductQRCode.vue?vue&type=template&id=68e5967b&scoped=true"
import script from "./ProductQRCode.vue?vue&type=script&lang=js"
export * from "./ProductQRCode.vue?vue&type=script&lang=js"
import style0 from "./ProductQRCode.vue?vue&type=style&index=0&id=68e5967b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e5967b",
  null
  
)

export default component.exports